import { useTranslation } from "react-i18next";

import { FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";

import { buildTPath } from "../contract-produc-classification.utils";

const Fields = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12} sm={12} textAlign="end">
          <SwitchInput name="enable" label={t(buildTPath("enabled"))} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormInput
            size="small"
            name="name"
            fullWidth
            label={t(buildTPath("name"))}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Fields;
